import { render, staticRenderFns } from "./PAuth.vue?vue&type=template&id=47850a7b&scoped=true&lang=pug"
import script from "./PAuth.vue?vue&type=script&lang=ts"
export * from "./PAuth.vue?vue&type=script&lang=ts"
import style0 from "./PAuth.vue?vue&type=style&index=0&id=47850a7b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47850a7b",
  null
  
)

export default component.exports